import * as React from 'react'
import { TextField as RadixTextField } from '@radix-ui/themes'
import { cn } from '../../lib/utils'

export interface TextFieldProps
  extends React.ComponentPropsWithoutRef<typeof RadixTextField.Root> {
  children?: React.ReactNode
}

export const TextField = ({ className, children, ...props }: TextFieldProps) => {
  return (
    <RadixTextField.Root
      size="3"
      radius="large"
      className={cn("!text-sm", className)}
      {...props}
    >
      {children}
    </RadixTextField.Root>
  )
}

export const TextFieldSlot = RadixTextField.Slot
